import axios from "common/configs/axiosConfigs";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ContactCard from "./components/ContactCard";

const Contacts = () => {
  const { company_id } = JSON.parse(localStorage.getItem("user-auth"));
  const [contacts, setContacts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredContacts, setFilteredContacts] = useState([]);

  const getContacts = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getContact",
        companyId: company_id,
      });
      if (data?.success) {
        setContacts(data?.data);
        setFilteredContacts(data?.data);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getContacts();
  }, []);
  const onSearch = ({ target: { value } }) => {
    setSearchText(value);
  };
  useEffect(() => {
    setFilteredContacts(
      contacts?.filter(
        (c) =>
          `${c?.first_name.toLocaleLowerCase()} ${c?.last_name.toLocaleLowerCase()}`?.includes(
            searchText.toLocaleLowerCase()
          ) || c?.phone.includes(searchText)
      )
    );
  }, [searchText, contacts]);
  return (
    <section>
      <h4 className="page-title">Contacts</h4>
      <div className="searchbar-cover mb-4">
        <i className="bi bi-search"></i>
        <input
          type="text"
          className="form-control"
          style={{ paddingLeft: 32 }}
          value={searchText}
          onChange={onSearch}
          placeholder="Search Contact"
        />
      </div>
      <div className="row gy-4">
        {filteredContacts?.map((c) => (
          <div className="col-lg-4 col-md-6" key={c?.id}>
            <ContactCard {...{ c, setContacts }} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Contacts;
